<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="dedi"></a><a id="page_5"><span class="txit">To<br/>SAMUEL
RIDDLE<br/>Owner of Man o’ War<br/>and<br/>MELVILLE CHURCH II<br/>President, The Virginia
Horseman’s Association in whose Thoroughbreds flows the blood of the Godolphin
Arabian</span></a><a id="page_6"></a></p><a id="page_6">
<p class="imager"><img alt="diagram" height="115" src="images/f0005-01.jpg" width="400"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?b37d4976